import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-filter-lined",
  "use": "rt-base-filter-lined-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-filter-lined\"><defs><style type=\"text/css\"></style></defs><path d=\"M667 685c4.317 0 7.864 3.465 7.996 7.752L675 693v187c0 17.523-13.917 31.714-31.273 31.996l-0.527 0.004H380.8c-17.424 0-31.516-14.015-31.796-31.47L349 880V693c0-4.317 3.465-7.864 7.752-7.996L357 685h310z m-64 72H421v83h182v-83z m277.1-645c24.255 0 39.493 26.169 28.055 47.36l-0.355 0.64-212.4 426.8c-5.43 10.464-16.219 17.03-27.943 17.197L667 604H357c-11.846 0-22.62-6.432-28.186-16.794l-0.214-0.406L116.3 160c-12.177-21.087 2.697-47.467 26.768-47.992l0.732-0.008h736.3z m-79.3 80H223.3l160.6 327.7c1.355 2.516 3.927 4.19 6.81 4.295l0.29 0.005h242.1c2.903 0 5.525-1.592 6.96-4.051l0.14-0.249L800.8 192z\" p-id=\"20920\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/filter-lined.svg
// module id = 1714
// module chunks = 228